import { request } from 'api';
import { ModerationRequest } from './types';

export const ModerationRequestService = {
  getCurrentModerationRequest() {
    return request<ModerationRequest>('get', '/api/v6/Onboarding/ModerationRequests');
  },
  getCurrentModerationRequestWithCheckLists() {
    return request<ModerationRequest>('get', '/api/v6/Onboarding/ModerationRequests/Checklists');
  },
  createModerationRequest(body: ModerationRequest) {
    return request<ModerationRequest>('post', '/api/v6/Onboarding/ModerationRequests', {
      data: body,
    });
  },
  createSecondaryModerationRequest(body: ModerationRequest) {
    return request<ModerationRequest>('post', '/api/v6/Onboarding/ModerationRequests/Secondaries', {
      data: body,
    });
  },
  draftModerationRequest(body: ModerationRequest) {
    return request<ModerationRequest>('put', `/api/v6/Onboarding/ModerationRequests/Drafts`, {
      data: body,
    });
  },
  sendModerationRequest(body: ModerationRequest) {
    return request<ModerationRequest>(
      'patch',
      `/api/v6/Onboarding/ModerationRequests/Moderations`,
      {
        data: body,
      }
    );
  },
  elaborateModerationRequest(body: ModerationRequest) {
    return request<ModerationRequest>(
      'post',
      `/api/v6/Onboarding/ModerationRequests/Elaborations`,
      {
        data: body,
      }
    );
  },
};
